jQuery(function ($) {
// Hardcoded positions of starting pixels inside the logo.
    var pixelDirections = [
        {x: +0, y: -1},
        {x: +1, y: +0},
        {x: +0, y: +1},
        {x: -1, y: +0}
    ];
    var refreshRate = 60; // Number of calls per second.
    var refreshScaling = 60 / refreshRate; // Number of calls per second.

    var pixels = [];
    var startingSpawnSteps = 60 * 3 / refreshScaling; // Each 3 seconds.
    var spawnSteps = 60 / 2 / refreshScaling; // Add first pixels after half a second.
    var speed = refreshScaling / 3;
    var decay = 150 / refreshScaling;
    var logo;
    var canvas;
    var ctx;

// Start coding pixels!
    jQuery(document).ready(function () {
        logo = jQuery('.navbar-brand .logo-change');
        canvas = jQuery('#logo-canvas');
        ctx = canvas[0].getContext("2d");
        ctx.lineWidth = 0.5;

        // Resize context to fit canvas.
        ctx.canvas.width = canvas.width();
        ctx.canvas.height = canvas.height();

        // Add even more pixels when hovering over the logo.
        logo.on('mouseenter', function () {
            startingSpawnSteps = refreshRate / 3;
            spawnSteps = 0;
            speed = refreshScaling / 2;
            decay = 150 / refreshScaling;
        });
        logo.on('mouseleave', function () {
            startingSpawnSteps = refreshRate * 3;
            spawnSteps = 0;
            speed = refreshScaling / 3;
            decay = 150 / refreshScaling;
        });

        // The main loop.
        setInterval(step, 1000 / refreshRate);
    });

    function step() {
        spawnPixels();
        movePixels();
    }

// Add pixels inside logo.
    function spawnPixels() {
        spawnSteps--;
        if (spawnSteps > 0) {
            return;
        }
        spawnSteps = startingSpawnSteps;

        // Size and position depends on logo size, which changes when the user scrolls down.
        var x = logo.offset().left - canvas.offset().left;
        var y = logo.offset().top - canvas.offset().top;
        var size;
        var dist;
        var topSpawn;
        var bottomSpawn;
        if ($('body').hasClass('scrolled-down')) {
            size = 2;
            dist = 3;
            topSpawn = {x: 25, y: 5};
            bottomSpawn = {x: 26, y: 42};
        }
        else {
            size = 4;
            dist = 6;
            topSpawn = {x: 46, y: 7};
            bottomSpawn = {x: 46, y: 76};
        }

        addPixel(x + topSpawn.x, y + topSpawn.y, size, 0, [0, 1]);
        addPixel(x + topSpawn.x - dist, y + topSpawn.y, size, 0, [0, 3]);
        addPixel(x + topSpawn.x + dist, y + topSpawn.y, size, 0, [0, 1]);

        addPixel(x + bottomSpawn.x, y + bottomSpawn.y, size, 2, [1, 2]);
        addPixel(x + bottomSpawn.x - dist, y + bottomSpawn.y, size, 2, [2, 3]);
        addPixel(x + bottomSpawn.x + dist, y + bottomSpawn.y, size, 2, [1, 2]);
    }

// Add a pixel.
    function addPixel(x, y, size, direction, availableDirections) {
        var pixel = {
            x: x,
            y: y,
            w: size,
            h: size,
            startingDecay: decay,
            speed: speed,
            decay: decay,
            startingDirection: direction,
            direction: direction,
            availableDirections: availableDirections,
            startingSteps: 52,
            steps: 52
        };

        pixels.push(pixel);
    }

    function movePixels() {
        var pixel, i;

        ctx.clearRect(0, 0, canvas[0].width, canvas[0].height);

        for (i = 0; i < pixels.length; i++) {
            pixel = pixels[i];

            pixel.x += pixelDirections[pixel.direction].x * pixel.speed;
            pixel.y += pixelDirections[pixel.direction].y * pixel.speed;
            pixel.decay--;
            pixel.steps--;

            if (pixel.steps <= 0) {
                pixel.steps = pixel.startingSteps;
                pixel.direction = pixel.availableDirections[randomIntFromInterval(0, pixel.availableDirections.length - 1)];
            }

            // Remove if decayed or offscreen.
            if (pixel.decay <= 0 || pixel.y + pixel.h < 0) {
                pixels.splice(i, 1);
            }
        }

        // Draw pixels. requestAnimationFrame broken in latest Firefox (occasionally nothing is displayed), as of 30 January 2015.
        if (/Chrome/.test(navigator.userAgent) || /Safari/.test(navigator.userAgent)) {
            window.requestAnimationFrame(drawPixels);
        }
        else {
            drawPixels();
        }
    }

    function drawPixels() {
        var pixel, x, y, i;

        ctx.clearRect(0, 0, canvas[0].width, canvas[0].height);

        for (i = 0; i < pixels.length; i++) {
            pixel = pixels[i];
            x = pixel.x - (pixel.w / 2);
            y = pixel.y - (pixel.h / 2);

            // Draw dark square for dark-mode.
            if (document.body.classList.contains('dark')) {
                ctx.beginPath();
                ctx.rect(x - 1, y - 1, pixel.w + 2, pixel.h + 2);
                ctx.fillStyle = ctx.fillStyle = 'rgba(24, 36, 43, ' + (pixel.decay / pixel.startingDecay) + ')';
                ctx.fill();
                ctx.closePath();

            // Draw white square.
            } else {
                ctx.beginPath();
                ctx.rect(x - 1, y - 1, pixel.w + 2, pixel.h + 2);
                ctx.fillStyle = ctx.fillStyle = 'rgba(255, 255, 255, ' + (pixel.decay / pixel.startingDecay) + ')';
                ctx.fill();
                ctx.closePath();
            }

            // Draw red square.
            ctx.beginPath();
            ctx.rect(x, y, pixel.w, pixel.h);
            ctx.fillStyle = ctx.fillStyle = 'rgba(238, 70, 70, ' + (pixel.decay / pixel.startingDecay) + ')';
            ctx.fill();
            ctx.closePath();
        }
    }

    function randomIntFromInterval(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
});
